import elysia from "./Lavia/elysia.webp";
import elysia2 from "./Lavia/elysia 2.webp";
import elysia3 from "./Lavia/elysia 3.webp";
import gracia from "./Lavia/cracia.webp";
import gracia2 from "./Lavia/cracia 2.webp";
import gracia3 from "./Lavia/cracia 3.webp";
import luxia from "./Lavia/luxia.webp";
import luxia2 from "./Lavia/luxia 2.webp";
import luxia3 from "./Lavia/luxia 3.webp";
import forest5 from "./Forestine/forest-5.webp";
import forest6 from "./Forestine/forest-6.webp";
import forest7 from "./Forestine/forest-7.webp";


const elysiaImages = [elysia, elysia2, elysia3];
const graciaImages = [gracia, gracia2, gracia3];
const luxiaImages = [luxia, luxia2, luxia3];
const forest5Images = [forest5];
const forest6Images = [forest6];
const forest7Images = [forest7];


export { elysiaImages, graciaImages, luxiaImages, forest5Images, forest6Images, forest7Images};
